import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Firebase yapılandırma - Gerçek projenizin değerlerini buraya ekleyin
const firebaseConfig = {
  apiKey: "AIzaSyBJJ7O5XHqe7uCvnw7-Ar3oEpBcRlcmDxc",
  authDomain: "iytemusic.firebaseapp.com",
  projectId: "iytemusic",
  storageBucket: "iytemusic.firebasestorage.app",
  messagingSenderId: "36652967034",
  appId: "1:36652967034:web:8ecbc42fddaeb6c59407c3",
  measurementId: "G-GD1XFJEJH8"
};



// Firebase uygulamasını başlat
const app = initializeApp(firebaseConfig);

// Firebase hizmetlerini dışa aktar
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'europe-west1'); // Region belirt
export const storage = getStorage(app);
export const addAdminRole = httpsCallable(functions, 'addAdminRole');

export default app; // Uygulamayı default export olarak dışa aktar